import httpClient from "./httpClient";
import { Organisation } from "../types/organisation";

const END_POINT = "/organisations";

const assignUserToOrganisation = async (
	userid: number,
	organisationid: number
): Promise<Organisation | undefined> => {
	const response = await httpClient.post(
		`${END_POINT}/${organisationid}/user/${userid}`
	);
	return response.data as Organisation;
};

const removeUserFromOrganisation = async (
	userid: number,
	organisationid: number
): Promise<Organisation | undefined> => {
	const response = await httpClient.delete(
		`${END_POINT}/${organisationid}/user/${userid}`
	);
	return response.data as Organisation;
};
export { assignUserToOrganisation, removeUserFromOrganisation };
